import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RouteLoader } from '~/components/loaders';
import { useCurrentUserLoader } from '../../hooks/useCurrentUserLoader';
export const PrivateRoute = ({ children, }) => {
    const { status } = useCurrentUserLoader();
    const { pathname, search } = useLocation();
    const referrer = `${pathname}${search}`;
    if (status === 'fetching') {
        return React.createElement(RouteLoader, null);
    }
    if (status === 'active') {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(Navigate, { to: "/login", state: { referrer } });
};
